import { useContext, useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
// eslint-disable-next-line import/no-cycle
import { COMPANY_MANAGEMENT_SERVICE, restApiRequest } from "src/utils/Api";
import newRelicErrorReport from "src/utils/newRelic/newRelicErrorReport";
import RbsContext from "src/utils/RoleBasedSecurity/RbsContext";
import { getBrowsingHistory } from "src/utils/browsingHistory";
import { SetSessionValue, GetSessionValue } from "./sessionHelper";

export const SELECTED_COMPANY_STORAGE_KEY = "selectedCompany";

const fetchAndSetCompanyData = async (companyId) => {
  try {
    const response = await restApiRequest(
      COMPANY_MANAGEMENT_SERVICE,
      `/companies/${companyId}`,
      "GET",
      {},
      []
    );
    const name = response?.shortName || "";
    SetCurrentCompany(companyId, name);
    return name;
  } catch (e) {
    newRelicErrorReport(
      e,
      "src/Pages/Report/helpers/companyHelper.js - fetchAndSetCompanyData"
    );
    SetCurrentCompany(companyId, "");
    return "";
  }
};

export function GetCurrentCompany() {
  const { userInfo } = useContext(RbsContext);
  const location = useLocation();
  const history = useHistory();

  const urlParams = new URLSearchParams(location.search);
  const urlCompanyId = urlParams.get("companyId");
  if (urlCompanyId) {
    fetchAndSetCompanyData(urlCompanyId);

    urlParams.delete("companyId");
    const newSearch = urlParams.toString();
    const newUrl = `${location.pathname}${newSearch ? `?${newSearch}` : ""}`;
    history.push(newUrl);

    return urlCompanyId;
  }

  if (userInfo.isAhr()) {
    return userInfo.getCompanyId();
  }

  const company = GetCurrentCompanyFromSession();
  return company ? company.id : "";
}

export function GetCurrentCompanyName() {
  const company = GetCurrentCompanyFromSession();
  return company ? company.name : "";
}

export function GetCurrentCompanyFromSession() {
  const savedCompanyInfo = GetSessionValue(SELECTED_COMPANY_STORAGE_KEY);
  return savedCompanyInfo;
}

export function SetCurrentCompany(id, name) {
  const company = {
    id,
    name,
  };
  SetSessionValue(SELECTED_COMPANY_STORAGE_KEY, company);
}

export const GetCompanyName = (companyId) => {
  const [companyName, setCompanyName] = useState(GetCurrentCompanyName());

  useEffect(() => {
    const fetchData = async () => {
      const name = await fetchAndSetCompanyData(
        companyId,
        "src/Pages/Report/helpers/companyHelper.js - GetCompanyName"
      );
      setCompanyName(name);
      SetCurrentCompany(companyId, name);
    };
    if (!companyName && companyId) {
      fetchData().catch((e) => {
        newRelicErrorReport(
          e,
          "src/Pages/Report/helpers/companyHelper.js - 39"
        );
      });
    }
  }, [companyName, companyId]);

  return companyName;
};

export default GetCurrentCompany;
